const $ = require('jquery');

window.jQuery = window.$ = $;

const dt = require('datatables.net');
window.DataTable = dt; 
$.fn.dataTable = dt;

require('datatables.net-bs4');
require('datatables.net-buttons'); 
require('datatables.net-buttons-bs4');
require('datatables.net-responsive-bs4');
require('ouanalyse-datatables.net-buttons-html5');

const datatables_default_options = {
    'deferRender': true,
    'autoWidth': false,
    'pageLength': 10,
    'lengthMenu': [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'All']],
    'ajax': {
        'dataSrc': 'data'
    },
    'stateSave': true,
    'stateDuration': 60 * 60,
    'dom': 'lfrtip<"spacer">B',
    'buttons': [
        {
            extend: 'csv',
            text: '<span class="glyphicons glyphicons-arrow-down"></span>&nbsp;CSV',
            exportOptions: {
                orthogonal: 'exportTabular'
            }
        }
    ],
};

module.exports = {
    create: function(selector, options) {
        var combined_options = $.extend({}, datatables_default_options, options);

        $(selector).on('init.dt', function () { 
            let wrapper = document.querySelector(`${selector}_wrapper`);
            if(!wrapper) return;
            let searchInput = wrapper.querySelector('.dt-search input');
            if(!searchInput) return;

            searchInput.addEventListener("focus", () => {
                wrapper.querySelector('.dt-search').classList.add("search-focused");
            });

            searchInput.addEventListener("blur", () => {
                wrapper.querySelector('.dt-search').classList.remove("search-focused");
            });
        });

        return $(selector).DataTable(combined_options);
    },
    reloadData: function(selector, callback) {
        $(selector).DataTable().ajax.reload((data) => {
            if(callback){
                callback(data);
            }                
        });                
    }
};
